import React from 'react';
import {WorkflowState} from '../../../models/enums/WorkflowState';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarBig.css';

interface ProgressBarBigProps {
	workflowState?: WorkflowState;
}

const ProgressBarBig = ({workflowState}: ProgressBarBigProps) => {

	const isSubmitted = () => {
		switch (workflowState.value) {
		case WorkflowState.Submitted.value:
		case WorkflowState.Completed.value:
		case WorkflowState.Error.value:
			return "big-back-blue";
		default:
			return "";
		}
	};

	const isCompleted = () => {
		switch (workflowState.value) {
		case WorkflowState.Completed.value:
		case WorkflowState.Error.value:
			return "big-back-blue";
		default:
			return "";
		}
	};

	return (
		<>
			<div className="big-progress-bar__title">
				<span className="em-c-field__label em-c-field__label--margin">Status</span>
				<WorkflowStateBadge workflowState={workflowState} />
			</div>
			<div className="big-progress-bar">
				<div className="big-progress-bar__line" />
				<div className="big-progress-bar__circle-with-title big-left-0">
					<div className={`big-progress-bar__circle ${isSubmitted()}`}>✓</div>
					<div className="big-progress-bar__circle--title">Submitted</div>
				</div>
				<div className="big-progress-bar__circle-with-title big-left-100">
					<div className={`big-progress-bar__circle ${isCompleted()}`}>✓</div>
					<div className="big-progress-bar__circle--title">{workflowState.value === WorkflowState.Error.value ? 'Error' : 'Completed'}</div>
				</div>
			</div>
		</>
	);
};

export default ProgressBarBig;
